<!-- src/views/panelMantenimiento/MantenimientoPage.vue -->
<template>
  <main class="page">
    <div class="card">
      <h1>Mantenimiento</h1>
      <p v-if="status?.message">{{ status.message }}</p>
      <p v-else>Estamos realizando mejoras. Regresamos pronto.</p>

      <div class="times" v-if="status?.startsAt || status?.endsAt">
        <div v-if="status?.startsAt">Inicio: {{ fmtMx(status.startsAt) }}</div>
        <div v-if="status?.endsAt">Fin estimado: {{ fmtMx(status.endsAt) }}</div>
      </div>

      <button class="btn" @click="refresh" :disabled="loading">
        {{ loading ? 'Actualizando…' : 'Revisar estado' }}
      </button>

      <p v-if="$canView('superadministrador')" class="tiny">
        Si eres admin, entra al <router-link to="/panel-mantenimiento">Panel de mantenimiento</router-link>.
      </p>
    </div>
  </main>
</template>
<script>
import { MaintenanceService } from './Services/MaintenanceService';

function parseMs(iso) {
  const t = Date.parse(iso);
  return Number.isNaN(t) ? null : t;
}

export default {
  name: 'MantenimientoPage',
  data() {
    return {
      status: null,
      loading: false,
      remainingMs: null,
      tickId: null,
      pollId: null,
      endTimeoutId: null,
      wasActive: false
    };
  },
  methods: {
    fmtMx(iso) {
      try {
        return new Date(iso).toLocaleString('es-MX', { timeZone: 'America/Mexico_City' });
      } catch {
        return new Date(iso).toLocaleString();
      }
    },
    stopAuto() {
      if (this.tickId) clearInterval(this.tickId);
      if (this.pollId) clearInterval(this.pollId);
      if (this.endTimeoutId) clearTimeout(this.endTimeoutId);
      this.tickId = this.pollId = this.endTimeoutId = null;
    },
    updateRemaining() {
      const e = parseMs(this.status?.endsAt);
      if (e == null) {
        this.remainingMs = null;
        return;
      }
      this.remainingMs = Math.max(0, e - Date.now());
    },
    startAuto() {
      this.stopAuto();

      const s = this.status;
      if (!s?.enabled) return;

      // polling cada 2 min mientras haya ventana activa o programada
      if (s.active || s.upcoming) {
        this.pollId = setInterval(() => this.refresh(true), 120000);
      }

      // si está activo, countdown y “check” exacto al final
      if (s.active) {
        this.wasActive = true;
        this.updateRemaining();
        this.tickId = setInterval(this.updateRemaining, 1000);

        const e = parseMs(s.endsAt);
        if (e != null) {
          const ms = Math.max(0, e - Date.now() + 1500);
          this.endTimeoutId = setTimeout(() => this.refresh(true), ms);
        }
      }
    },
    async refresh(force = false) {
      this.loading = true;
      try {
        this.status = await MaintenanceService.getStatus({ force });
        this.startAuto();

        // Si ya NO está activo, vuelve y recarga
        if (this.status?.enabled && !this.status?.active) {
          const redirect = this.$route.query.redirect;
          const safe = (typeof redirect === 'string' && redirect.startsWith('/') && redirect !== '/mantenimiento')
            ? redirect
            : '/';

          // evita recargar si nunca estuvo active
          await this.$router.replace(safe);
          if (this.wasActive) window.location.reload();
        }
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.refresh(true);
  },
  beforeUnmount() {
    this.stopAuto();
  }
};
</script>

<style lang="sass" scoped>

.page
  min-height: 100vh
  display: grid
  place-items: center
  padding: 24px
  background: radial-gradient(70% 60% at 10% 10%, rgba(37, 99, 235, .10), transparent 60%), #f1f5f9

.card
  width: min(520px, 92vw)
  border-radius: 18px
  padding: 18px
  border: 1px solid rgba(15, 23, 42, .10)
  background: #ffffff
  color: #0f172a
  box-shadow: 0 18px 55px rgba(2, 6, 23, .12)

h1
  margin: 0
  font-size: 1.4rem
  font-weight: 1000
  color: #0f172a

p
  margin: 10px 0 0
  color: #475569
  font-weight: 650

.times
  margin-top: 10px
  font-size: .9rem
  color: #334155
  display: grid
  gap: 4px

.btn
  margin-top: 14px
  border-radius: 999px
  border: 1px solid rgba(37, 99, 235, .25)
  background: #2563eb
  color: #ffffff
  padding: 10px 14px
  font-weight: 900
  cursor: pointer
  box-shadow: 0 10px 20px rgba(37, 99, 235, .18)
  transition: transform .05s ease, filter .15s ease, box-shadow .15s ease
  &:hover
    filter: brightness(1.03)
  &:active
    transform: translateY(1px)
  &:disabled
    opacity: .65
    cursor: not-allowed
    box-shadow: none

.tiny
  margin-top: 12px
  font-size: .85rem
  color: #64748b
  a
    color: #2563eb
    text-decoration: underline
</style>